/// <amd-module name="VSSUI/Components/VssDetailsList/VssDetailsListGroupHeader" />
import * as React from "react";
import { FocusZone, FocusZoneDirection } from "OfficeFabric/FocusZone";
import { BaseComponent } from "OfficeFabric/Utilities";
import { css } from "VSSUI/Util";
import { IVssDetailsListGroupHeaderProps } from "./VssDetailsList.Props";

/**
 * Helper for the styling of group headers in VssDetailsList
 */
/** @deprecated */
export class VssDetailsListGroupHeader extends BaseComponent<IVssDetailsListGroupHeaderProps> {
    public render(): JSX.Element {
        const { text, textCssClassName, onRenderContent } = this.props;

        return (
            <div className="vss-DetailsList--groupHeader" data-is-focusable="true">
                <FocusZone direction={FocusZoneDirection.horizontal}>
                    {onRenderContent ? onRenderContent() : <div className={css("vss-DetailsList--groupHeaderText", textCssClassName)}>{text}</div>}
                </FocusZone>
            </div>
        );
    }
}
